import React from "react";
import { Link } from "react-router-dom";

const Not_Found = () => {
  return (
    <div>
      {/* <!-- tpm-header-area start --> */}
      {/* <!-- tpm-header-area start --> */}
 
      {/* <!-- tpm-header-area end --> */}

      {/* <!-- Start Breadcrumb area  --> */}

      {/* <!-- Start Breadcrumb area  --> */}
      <div className="breadcrumb-area bg_image tmp-section-gap breadcrumb-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-inner text-center">
                <h1 className="title split-collab">Error Page</h1>
                <ul className="page-list">
                  <li className="tmp-breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="icon">
                    <i className="fa-solid fa-angle-right"></i>
                  </li>
                  <li className="tmp-breadcrumb-item active">FAQ's</li>
                </ul>
                <div className="circle-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End Breadcrumb area  --> */}
      {/* <!-- End Breadcrumb area  --> */}

      {/* <!-- tmp breadcrumb area start --> */}
      <div className="error-page-area tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="error-inner text-center">
                <div className="thumbnail">
                  <img src="assets/images/error/group2.png" alt="error" />
                  <img src="assets/images/error/404.png" alt="error" />
                  <img src="assets/images/error/group1.png" alt="error" />
                </div>

                <h2 className="title">Oops! Nothing Was Found</h2>
                <p className="description text-center">
                  Household shameless incommode at no objection behaviour.
                  Especially do at he possession insensible sympathize
                  boisterous it. Songs he on an widen me event truth.
                </p>

                <Link to="/" className="tmp-btn btn-primary">
                  Back To Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- tmp breadcrumb area end --> */}

      {/* <!-- Start Footer Area  --> */}
      {/* <!-- Start Footer Area  --> */}
      {/* <footer className="footer-area footer-style-one-wrapper bg-color-footer bg_images tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="subscribe-area subscribe-style-1">
                <div className="subscribe-inner">
                  <div className="title">Subscribe to Newsletter</div>
                  <form action="#" className="newsletter-form-1 mt--40">
                    <input type="email" placeholder="Your Email" required />
                    <button type="submit" className="tmp-btn btn-primary">
                      Subscribe Now{" "}
                      <i className="fa-sharp fa-regular fa-paper-plane"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-main footer-style-one">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-wrapper border-right mr--20">
                  <div className="logo">
                    <Link to="/">
                      <img src="assets/images/logo/logo-02.svg" alt="logo" />
                      <img height="61" width="188" src="/assets/images/logo/starpath-logo.svg" alt="logo" />
                    </Link>
                  </div>

                  <p className="description">
                    Proin Pretium Sem Libero, Nec Aliquet Augue Lobortis In.
                    Phasellus Nibh Quam, Molestie Id Est Sit Amet, Luctus
                    Pulvinar
                  </p>

                  <div className="day-time">
                    <div className="icon">
                      <i className="fa-solid fa-alarm-clock"></i>
                    </div>
                    <div className="content">
                      <div className="day">Sunday - Friday:</div>
                      <div className="time">9:00 AM – 8:00 PM</div>
                    </div>
                  </div>

                  <ul className="social-icons solid-social-icons rounded-social-icons">
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6">
                <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                  <h5 className="ft-title">Quick Link</h5>
                  <ul className="ft-link">
                    <li>
                      <Link to="/about">About Company</Link>
                    </li>
                    <li>
                      <Link to="/team"> Our Team</Link>
                    </li>
                    <li>
                      <Link to="/service">Our Services</Link>
                    </li>
                    <li>
                      <Link to="/blog">News & Media</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>

                    <li>
                      <Link to="/faq">Support</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper pr--15">
                  <h5 className="ft-title">Recent Post</h5>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src="assets/images/footer/small-post.jpg"
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 2022</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Day tree hide from hath gathered multy
                        </h6>
                      </Link>
                    </div>
                  </div>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src="assets/images/footer/small-post-2.jpg"
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 2022</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Saving Time Achieving Success in Business
                        </h6>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper">
                  <h5 className="ft-title">Official info:</h5>
                  <ul className="ft-link">
                    <li className="ft-location">
                      5919 Trussville Crossings Pkwy, new Dusting town, Austria
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-solid fa-envelope-open-text"></i>
                        </div>

                        <div className="content">
                          <span>E-mail:</span>
                          <Link to="mailto:webmaster@example.com">
                            info@uibundle.com
                          </Link>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-light fa-phone"></i>
                        </div>
                        <div className="content">
                          <span>Phone:</span>
                          <Link to="tel:+4733378901">+123 34598768</Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright-area-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-wrapper">
                <p>
                  © Copyright 2024. All Rights Reserved by{" "}
                  <Link to="#">Themes-Park</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End Footer Area  --> */}
      {/* <!-- End Footer Area  --> */}

      <div
        id="overlay_every-where"
        data-tmp-cursor="md text-black dark:text-white opacity-10"
        data-tmp-cursor-icon="fa-regular fa-x fa-fw"
      ></div>

      {/* <!-- progress area start --> */}
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
      {/* <!-- progress area end --> */}

      {/* <!-- ==================== Start Loading ==================== --> */}
      {/* 
    <div className="loader-wrap">
        <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
            <path id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"></path>
        </svg>

        <div className="loader-wrap-heading">
            <div className="load-text">
                <span>L</span>
                <span>o</span>
                <span>Link</span>
                <span>d</span>
                <span>i</span>
                <span>n</span>
                <span>g</span>
            </div>
        </div>
    </div> */}
    </div>
  );
};

export default Not_Found;
